const ftrInputs = document.querySelectorAll('.ftr-input');

ftrInputs.forEach((ftrInput) => {
    ftrInput.addEventListener('input', () => {
        if (ftrInput.value) {
            ftrInput.classList.add('filled');
        } else {
            ftrInput.classList.remove('filled');
        }
    });
});
